<div class="d-flex justify-content-center align-items-center reset-otp">

    @if(!passwordChanged){

    <div class="d-inline justify-content-center align-items-center box mt-4 mb-3">

        <div class="d-flex justify-content-center ">
            <img src="assets/images/logo-t.png" alt="HPSLife Logo" width="120px" height="50px" />
        </div>

        <p class="d-flex justify-content-center fs-17 fw-500 mt-3">Reset Password</p>
        <p class="d-flex justify-content-center fs-12"> Enter your email to continue with the password reset.</p>
        @if(passwordChanged){

        <p class="d-flex justify-content-center reset-subtitle"> Please Kindly Enter Your Username</p>
        }
        <form [formGroup]="resetPassword" (ngSubmit)="onReset()" (keypress)="onKeyDown($event)">
            <div class="mt-4">
                <mat-form-field appearance="outline">
                    <mat-label>Email</mat-label>
                    <input matInput type="email" formControlName="username" [disabled]="userNameValid">
                    @if(userNameValid){
                    <div matTextSuffix="" class="p-1">

                        <svg matTextPrefix="" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                            viewBox="0 0 16 16">
                            <g fill="none" stroke="#0eea12" stroke-linecap="round" stroke-linejoin="round"
                                stroke-width="1.5">
                                <path
                                    d="M14.25 8.75c-.5 2.5-2.385 4.854-5.03 5.38A6.25 6.25 0 0 1 3.373 3.798C5.187 1.8 8.25 1.25 10.75 2.25" />
                                <path d="m5.75 7.75l2.5 2.5l6-6.5" />
                            </g> verified
                        </svg>
                        <span class="p-1 verified-colour">Verified</span>
                    </div>
                    }
                    <mat-error *ngIf="resetPassword.get('username')?.hasError('required')">
                        Email is required
                    </mat-error>
                    <mat-error
                        *ngIf="resetPassword.get('username')?.hasError('email') && !resetPassword.get('username')?.hasError('required')">
                        Invalid email
                    </mat-error>
                </mat-form-field>

            </div>
            @if(userNameValid){
            <div>
                <mat-form-field appearance="outline">
                    <mat-label>New Password</mat-label>
                    <input matInput [type]="showPassword? 'text' : 'password'" id="password" formControlName="password">



                    <span class="cursor-pointer" (click)="togglePasswordVisibility()">
                        @if(!showPassword){
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24">
                            <g fill="none" stroke="#575555" stroke-width="1.2">
                                <path
                                    d="M12 5c-5.444 0-8.469 4.234-9.544 6.116c-.221.386-.331.58-.32.868c.013.288.143.476.402.852C3.818 14.694 7.294 19 12 19s8.182-4.306 9.462-6.164c.26-.376.39-.564.401-.852s-.098-.482-.319-.868C20.47 9.234 17.444 5 12 5Z" />
                                <circle cx="12" cy="12" r="3" />
                            </g>
                        </svg>
                        }
                        @else {
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
                            <path fill="#575555"
                                d="M2.54 4.71L3.25 4L20 20.75l-.71.71l-3.34-3.35c-1.37.57-2.87.89-4.45.89c-4.56 0-8.5-2.65-10.36-6.5c.97-2 2.49-3.67 4.36-4.82zM11.5 18c1.29 0 2.53-.23 3.67-.66l-1.12-1.13c-.73.5-1.6.79-2.55.79C9 17 7 15 7 12.5c0-.95.29-1.82.79-2.55L6.24 8.41a10.64 10.64 0 0 0-3.98 4.09C4.04 15.78 7.5 18 11.5 18m9.24-5.5C18.96 9.22 15.5 7 11.5 7c-1.15 0-2.27.19-3.31.53l-.78-.78C8.68 6.26 10.06 6 11.5 6c4.56 0 8.5 2.65 10.36 6.5a11.47 11.47 0 0 1-4.07 4.63l-.72-.73c1.53-.96 2.8-2.3 3.67-3.9M11.5 8C14 8 16 10 16 12.5c0 .82-.22 1.58-.6 2.24l-.74-.74c.22-.46.34-.96.34-1.5A3.5 3.5 0 0 0 11.5 9c-.54 0-1.04.12-1.5.34l-.74-.74c.66-.38 1.42-.6 2.24-.6M8 12.5a3.5 3.5 0 0 0 3.5 3.5c.67 0 1.29-.19 1.82-.5L8.5 10.68c-.31.53-.5 1.15-.5 1.82" />
                        </svg>
                        }
                    </span>

                    <mat-error *ngIf="resetPassword.get('password')?.hasError('required')">
                        Password is required
                    </mat-error>

                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline">
                    <mat-label>Confirm Password</mat-label>
                    <input matInput [type]="showPasswordConfirm ? 'text' : 'password'"
                        formControlName="reenterPassword">
                    <span class="cursor-pointer" (click)="togglePasswordVisibilityConfirm()">
                        @if(!showPasswordConfirm){
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24">
                            <g fill="none" stroke="#575555" stroke-width="1.2">
                                <path
                                    d="M12 5c-5.444 0-8.469 4.234-9.544 6.116c-.221.386-.331.58-.32.868c.013.288.143.476.402.852C3.818 14.694 7.294 19 12 19s8.182-4.306 9.462-6.164c.26-.376.39-.564.401-.852s-.098-.482-.319-.868C20.47 9.234 17.444 5 12 5Z" />
                                <circle cx="12" cy="12" r="3" />
                            </g>
                        </svg>
                        }
                        @else {
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
                            <path fill="#575555"
                                d="M2.54 4.71L3.25 4L20 20.75l-.71.71l-3.34-3.35c-1.37.57-2.87.89-4.45.89c-4.56 0-8.5-2.65-10.36-6.5c.97-2 2.49-3.67 4.36-4.82zM11.5 18c1.29 0 2.53-.23 3.67-.66l-1.12-1.13c-.73.5-1.6.79-2.55.79C9 17 7 15 7 12.5c0-.95.29-1.82.79-2.55L6.24 8.41a10.64 10.64 0 0 0-3.98 4.09C4.04 15.78 7.5 18 11.5 18m9.24-5.5C18.96 9.22 15.5 7 11.5 7c-1.15 0-2.27.19-3.31.53l-.78-.78C8.68 6.26 10.06 6 11.5 6c4.56 0 8.5 2.65 10.36 6.5a11.47 11.47 0 0 1-4.07 4.63l-.72-.73c1.53-.96 2.8-2.3 3.67-3.9M11.5 8C14 8 16 10 16 12.5c0 .82-.22 1.58-.6 2.24l-.74-.74c.22-.46.34-.96.34-1.5A3.5 3.5 0 0 0 11.5 9c-.54 0-1.04.12-1.5.34l-.74-.74c.66-.38 1.42-.6 2.24-.6M8 12.5a3.5 3.5 0 0 0 3.5 3.5c.67 0 1.29-.19 1.82-.5L8.5 10.68c-.31.53-.5 1.15-.5 1.82" />
                        </svg>
                        }
                    </span>

                    <mat-error *ngIf="resetPassword.get('reenterPassword')?.hasError('required')">
                        Confirm Password is required
                    </mat-error>
                </mat-form-field>


                <mat-error class="password-error align-items-center p-2 "
                    *ngIf="resetPassword.get('password')?.value !=resetPassword.get('reenterPassword')?.value">
                    <div>Confirm password and new password must be same </div>
                </mat-error>

            </div>

            <!-- <div *ngIf="resetPassword.get('confirmPassword')?.errors?.['passwordMismatch']">
        Passwords do not match.
      </div> -->

            }
            <div class="mb-3">
                <button class="primaryBtn w-100" [disabled]="resetPassword.invalid "
                    (click)="onEnterPressed($event)"><span class="btnContent">Submit</span></button>
            </div>

        </form>

    </div>
    }

    @if(passwordChanged){
    <div class="success-box">
        <div class="tick-container">
            <svg class="animated-tick" viewBox="0 0 52 52">
                <circle class="tick-circle" cx="26" cy="26" r="25" fill="none" />
                <path class="tick-check" fill="none" d="M14 27l7 7 16-16" />
            </svg>
        </div>

        <p class="fs-15 fw-500">Password Changed !!!</p>
        <p class="fs-12">You can now sign in with your new
            credentials.</p>

        <div class="text-center mt-3 d-flex justify-content-center align-items-center">
            <button class="primaryBtn reset-button" (click)="onRouteToLogin()">SIGN IN</button>
        </div>
    </div>

    }
</div>